module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mine-customer"
  }, [_c('div', [_c('div', {
    staticClass: "user-header"
  }, [_c('div', {
    staticClass: "user-message"
  }, [_c('div', {
    staticClass: "user-detail"
  }, [_c('div', {
    staticClass: "user-detail-right"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v("HI , " + _vm._s(_vm.row.name))]), _vm._v(" "), _c('div', {
    staticClass: "user-invite",
    on: {
      "click": _vm.toBusinessList
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-qiehuan.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "invite-num"
  }, [_vm._v("[切换省市]")])])]), _vm._v(" "), _c('div', {
    staticClass: "user-setting-box",
    on: {
      "click": _vm.toBusinessSet
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-seeting.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "user-black flex-between",
    on: {
      "click": _vm.toWeiyuanhuiDetail
    }
  }, [_c('div', {
    staticClass: "user-black-top"
  }, [_c('div', {
    staticClass: "user-moneys"
  }, [_c('div', {
    staticClass: "user-moneys-title"
  }, [_vm._v("年度赛事(场)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.sai_year_count))])]), _vm._v(" "), _c('div', {
    staticClass: "user-moneys",
    on: {
      "click": _vm.toWeiyuanhuiDetail
    }
  }, [_c('div', {
    staticClass: "user-moneys-title"
  }, [_vm._v("累计赛事(场)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.sai_count))])])]), _vm._v(" "), _c('div', {
    staticClass: "user-black-middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "user-black-top"
  }, [_c('div', {
    staticClass: "user-moneys",
    on: {
      "click": _vm.toWeiyuanhuiDetail
    }
  }, [_c('div', {
    staticClass: "user-moneys-title"
  }, [_vm._v("年度培训(场)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.huiyi_year_count))])]), _vm._v(" "), _c('div', {
    staticClass: "user-moneys"
  }, [_c('div', {
    staticClass: "user-moneys-title"
  }, [_vm._v("累计培训(场)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.huiyi_count))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "credit-box"
  }, [_c('div', {
    staticClass: "credit-ul"
  }, [_c('div', {
    staticClass: "credit-li"
  }, [_c('span', [_vm._v(_vm._s(_vm.row.danwei_count))]), _vm._v(" "), _c('div', {
    staticClass: "credit-text"
  }, [_vm._v("单位数")])]), _vm._v(" "), _c('div', {
    staticClass: "credit-li"
  }, [_c('span', [_vm._v(_vm._s(_vm.row.club_count))]), _vm._v(" "), _c('div', {
    staticClass: "credit-text"
  }, [_vm._v("俱乐部")])]), _vm._v(" "), _c('div', {
    staticClass: "credit-li"
  }, [_c('span', [_vm._v(_vm._s(_vm.row.qcxj_count))]), _vm._v(" "), _c('div', {
    staticClass: "credit-text"
  }, [_vm._v("考级中心/点")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mini-nav"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.toDetail('WyhExameCenterList')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-qicaixingji.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("七彩星级")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toDetail('WyhClubList')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-julebu.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("俱乐部")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toDetail('WyhDakejianList')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-dakejianshenbao.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("大课间申报")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toDetail('WyhSihaoList')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-sihaoyundongyaun.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("四好运动员")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toDetail('WyhHuiyiApplyList')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-huiyi.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("会议")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toDetail('WyhJiaolianList')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-jiaolianyuanguanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("教练员管理")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toDetail('WyhCaipanList')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("裁判员管理")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toDetail('WyhSaiApplyList')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-saishi.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("赛事")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toDetail('WyhOrderList')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-customerorder.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("客户订单管理")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toDetail('WyhConfigureList')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-sellrorder.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("销售单管理")])])])]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04df6db3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/index/WeiyuanhuiIndex.vue
// module id = 2163
// module chunks = 0